<template>
  <b-container>
    <b-row>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </b-row>
    <h2>{{ $t("tracking.occurrenceType.list") }}</h2>

    <b-row>
      <router-link :to="getUrlCreate()">
        <b-button size="sm">{{ $t("geral.create") }}</b-button>
      </router-link>
    </b-row>

    <b-row>
      <b-table
        ref="table"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :filter="tableFilters"
        :filter-debounce="500"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
      >
        <template v-slot:cell(actions)="data">
                
          <router-link :to="getUrlEdit(data.item)">
            <b-button size="sm" class="btn-checklist">
              {{ $t("geral.edit") }}
            </b-button>
          </router-link>
          <b-button
            v-if="isOccurrenceTypeActive(data.item)"
            size="sm"
            class="btn-checklist ml-2"
            @click="occurrenceTypeDeactivate(data.item)"
            >{{ $t("geral.delete") }}</b-button
          >
          <b-button
            v-else
            size="sm"
            class="btn-checklist ml-2"
            @click="occurrenceTypeActivate(data.item)"
            >{{ $t("geral.activate") }}</b-button
          >
        </template>
        <template v-slot:cell(ativo)="data">
          {{ data.value ? "Sim" : "Não" }}
        </template>
      </b-table>
    </b-row>

    <table-pagination-props
      :currentPage.sync="tableCurrentPage"
      :pageOptions.sync="tablePageOptions"
      :perPage.sync="tablePerPage"
      :rowCount.sync="tableRowCount"
    >
    </table-pagination-props>
  </b-container>
</template>
<script>
import TablePaginationProps from "@/components_rms/base/TablePaginationProps.vue";
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";

export default {
  name: "OccurrenceType",
  components: {
    FadeAlertDanger,
    SuccessFadeAlert,
    TablePaginationProps,
  },
  data: function () {
    return {
      alert: {
        error: "",
        success: "",
      },
      isBusy: false,
      fields: [
        {
            key: "actions",
          sortable: false,
          label: "",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "sequenceNumber",
          filterKey: "sequenceNumber",
          label: this.$t("tracking.occurrenceType.model.sequenceNumber"),
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "description",
          filterKey: "description",
          label: this.$t("tracking.occurrenceType.model.description"),
        },
        {
          key: "active",
          filterKey: "active",
          label: "Ativo",
          sortable: true,
          formatter: (value, key, item) => {
            if (value) {
              return "Sim";
            }
            return "Não";
          },
        },
      ],
      computed: {},
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      tableFilters: {
        description: "",
        sequenceNumber: "",
        active: true,
      },
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
    };
  },
  computed: {},
  methods: {
    getUrlCreate(){
        return `/trackingShippingCompany/occurrenceType/Create`;
    },
    getUrlEdit(occurrence) {
      return `/trackingShippingCompany/occurrenceType/edit/${occurrence.id}`;
    },
    isOccurrenceTypeActive(occurrenceType) {
      if (occurrenceType) {
        return occurrenceType.active
      }
      return true;//
    },
    myProvider(ctx, callback) {
      this.isBusy = true;

      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
        active: true
      };
      this.$api
        .post("/v1/OccurrenceType/list", apiParam)
        .then((response) => {
          const items = response.data.items;
          // console.log = ("ok")
          // console.log(items);
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          // console.log("tableRowCount")
          // console.log(this.tableRowCount)
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
    occurrenceTypeActivate(occurrenceType) {
      this.$api
        .get("v1/OccurrenceType/activate/"+ occurrenceType.id.toString())
        .then((response) => {
          // console.log("entrou")
          occurrenceType.active = true;
          this.alert.success = response.data.title;
          this.$refs.alert.show();
        })
        .catch((error) => {
          console.log(error.response);
          this.alert.error =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
    occurrenceTypeDeactivate(occurrenceType) {
      this.$api
        .get("v1/OccurrenceType/Deactivate/" + occurrenceType.id.toString())
        .then((response) => {
          // console.log("entrou")
          occurrenceType.active = false;
          this.alert.success = response.data.title;
          this.$refs.alert.show();
        })
        .catch((error) => {
          console.log(`error: ${error}`);
          console.log(error);
          console.log(`error.response: ${error.response}`);
          console.log(error.response);

          this.alert.error =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
  },
};
</script>
